import { Box, Button, TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import { ImageContainer } from "../../../../shared/components/ImageContainer";
import { EditIcon, TrashIcon } from "../../../../assets/icons/icons";
import DeleteDialog from "../../../products/product/DeleteDialog";
import { toastError, toastSuccess } from "../../../../utils/ToastMessage";
import { useGlobalContext } from "../../../../App";
import { useNavigate } from "react-router-dom";
import { deletePricing } from "../../../../services/pricingSection";

interface tableRowProps {
  row: any;
  handleRefreshData?: any;
  onDragStart: () => void;
  onDragOver: (e: React.DragEvent<HTMLTableRowElement>) => void;
  onDrop: () => void;
}

const Row: React.FC<tableRowProps> = ({
  row,
  handleRefreshData,
  onDragStart,
  onDragOver,
  onDrop,
}) => {
  const navigate = useNavigate();
  const { setAddCategoryPopup, setIsEditCategoryState } = useGlobalContext();
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleDeletePricing = async () => {
    try {
      await deletePricing(row?._id).then((res: any) => {
        toastSuccess("Successfully Deleted!", "Pricing deleted successfully.");
        handleRefreshData();
      });
    } catch (error) {
      toastError("Ops! Something went wrong.", "Failed deleting the pricing.");
      console.error("Error deleting pricing:", error);
    } finally {
      setIsDeleteDialogVisible(false);
    }
  };

  const handleUpdatePricing = () => {
    setIsEditCategoryState(true);
    setAddCategoryPopup(true);
  };

  return (
    <TableRow
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onClick={() => {}}
      sx={{
        cursor: "grab",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
        width: "100%",
        height: "66px",
        display: "flex",
        justifyContent: "space-between",
        paddingRight: "14px",
        borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
      }}
      hover
      role="checkbox"
      tabIndex={-1}
      key={row?._id}
    >
      <TableCell
        sx={{
          minWidth: "146px",
          borderBottom: "none",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            color: "#FFFFFF",
          }}
        >
          {row?.value || "-"}
        </Box>
      </TableCell>

      <TableCell
        sx={{
          minWidth: "146px",
          borderBottom: "none",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            color: "#FFFFFF",
          }}
        >
          {row?.link || "-"}
        </Box>
      </TableCell>

      <TableCell
        sx={{
          minWidth: "125px",
          borderBottom: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "72px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <Button
            onClick={() => {
              handleUpdatePricing();
              navigate(`/settings/pricing`, {
                state: {
                  categoryData: row,
                },
              });
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
              ":hover": {
                bgcolor: "none !important",
              },
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title={"edit"}
            >
              {EditIcon}
            </ImageContainer>
          </Button>

          <Button
            onClick={() => {
              setIsDeleteDialogVisible(true);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title="trash"
            >
              {TrashIcon}
            </ImageContainer>
          </Button>
        </Box>

        {isDeleteDialogVisible && (
          <DeleteDialog
            title="Are you sure you want to delete this Pricing?"
            setIsDeleteDialogVisible={setIsDeleteDialogVisible}
            deleteAction={() => {
              handleDeletePricing();
            }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default Row;
